module.exports = __webpack_public_path__ + "assets/img/info.webp?94137bacf8a9b1127ce64ee7a61f8f5c";